import { request } from "./http";

export interface GlAccount {
  id: string;
  code: string;
  label: string;
  kind: string;
  currency: string;
  entity_ref: string | null;
  created_at: string | null;
}

export interface GlEntry {
  id: string;
  txn_id: string | null;
  kind: string;
  debit_account_id: string | null;
  credit_account_id: string | null;
  amount: string;
  currency: string;
  reference: string | null;
  note: string | null;
  occurred_at: string | null;
}

export interface BankStatement {
  id: string;
  treasury_account_id: string | null;
  statement_date: string | null;
  opening_balance: string;
  closing_balance: string;
  line_count: number;
  source: string | null;
  imported_at: string | null;
}

export interface ReconRun {
  id: string;
  treasury_account_id: string | null;
  run_date: string | null;
  bank_total: string;
  ledger_total: string;
  difference: string;
  status: string;
  note: string | null;
  created_at: string | null;
}

export interface ReconBreak {
  id: string;
  run_id: string | null;
  kind: string;
  amount: string;
  currency: string;
  note: string | null;
  resolved: boolean;
  resolution_note: string | null;
  created_at: string | null;
  resolved_at: string | null;
}

export interface CorporateAction {
  id: string;
  instrument_id: string | null;
  kind: string;
  announce_date: string | null;
  ex_date: string | null;
  pay_date: string | null;
  cash_amount: string | null;
  cash_currency: string | null;
  ratio: string | null;
  status: string;
  note: string | null;
  applied_at: string | null;
}

export interface FundingRate {
  id: string;
  instrument_id: string | null;
  venue: string;
  rate: string;
  mark_price: string | null;
  interval_seconds: number | null;
  funded_at: string | null;
}

export const accounting = {
  glAccounts: () => request<GlAccount[]>("/api/v1/admin/gl/accounts"),
  glEntries: () => request<GlEntry[]>("/api/v1/admin/gl/entries"),
  bankStatements: () => request<BankStatement[]>("/api/v1/admin/bank-statements"),
  reconRuns: () => request<ReconRun[]>("/api/v1/admin/reconciliation"),
  reconBreaks: (resolved?: boolean) =>
    request<ReconBreak[]>(
      `/api/v1/admin/reconciliation/breaks${resolved !== undefined ? `?resolved=${resolved}` : ""}`,
    ),
  corporateActions: () => request<CorporateAction[]>("/api/v1/admin/corporate-actions"),
  fundingRates: () => request<FundingRate[]>("/api/v1/admin/funding-rates"),
  resolveBreak: (id: string, resolution_note?: string) =>
    request<{ id: string; resolved: boolean }>(
      `/api/v1/admin/reconciliation/breaks/${id}/resolve`,
      { body: { resolution_note } },
    ),
  createCorporateAction: (body: CorporateActionCreate) =>
    request<{ id: string; status: string }>("/api/v1/admin/corporate-actions", { body }),
  applyDueCorporateActions: () =>
    request<Record<string, number>>("/api/v1/admin/corporate-actions/apply-due", { body: {} }),
};

export interface CorporateActionCreate {
  instrument_id: string;
  kind: string;
  ex_date: string;
  announce_date?: string | null;
  pay_date?: string | null;
  cash_amount?: string | number | null;
  cash_currency?: string | null;
  ratio?: string | number | null;
  note?: string | null;
}
